var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurgery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M75.14,22.442c-1.159-1.159-2.702-1.796-4.346-1.796s-3.187,0.638-4.345,1.797L39.793,49.098 c-0.002,0.002-0.004,0.004-0.006,0.006L19.514,69.378c-0.781,0.781-0.781,2.047,0,2.828c1.943,1.943,4.525,3.016,7.271,3.018 c0.003,0,0.006,0,0.01,0c2.744,0,5.323-1.068,7.264-3.01c0,0,0,0,0,0c1.799-1.799,2.844-4.129,2.995-6.638l6.08-6.08 c0.339,0.057,0.68,0.092,1.019,0.092c1.594,0,3.155-0.623,4.331-1.8L75.14,31.133l0.001,0c1.149-1.151,1.79-2.689,1.802-4.359 C76.931,25.132,76.29,23.594,75.14,22.442z M33.656,63.317c-0.387,0.387-0.599,0.915-0.585,1.463 c0.042,1.74-0.611,3.376-1.841,4.605c0,0,0,0,0,0c-1.185,1.186-2.76,1.838-4.436,1.838c-0.002,0-0.004,0-0.006,0 c-0.989-0.001-1.943-0.229-2.804-0.659L38.549,56c0.016,0.035,0.039,0.068,0.056,0.103c0.094,0.196,0.198,0.386,0.313,0.572 c0.026,0.041,0.048,0.084,0.075,0.125c0.14,0.214,0.295,0.419,0.463,0.616c0.016,0.019,0.028,0.04,0.044,0.058L33.656,63.317z  M72.311,28.306L45.655,54.96c-0.614,0.617-1.535,0.794-2.365,0.448c-0.246-0.1-0.47-0.25-0.668-0.448 c-0.403-0.403-0.625-0.941-0.625-1.517c0-0.144,0.014-0.285,0.041-0.423c0.081-0.413,0.282-0.792,0.584-1.094 c0.001-0.001,0.001-0.002,0.002-0.003l26.653-26.652c0.403-0.403,0.941-0.625,1.517-0.625s1.114,0.222,1.517,0.625 c0.403,0.403,0.628,0.947,0.632,1.503C72.938,27.358,72.714,27.902,72.311,28.306z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurgery);
export default __webpack_public_path__ + "static/media/surgery.770eca6293ab42f2a73eb396f11ddb3d.svg";
export { ForwardRef as ReactComponent };